export default __webpack_public_path__ + "static/media/accepted.6f050c7a.svg";